
import Header from "@/components/Header";
import Footer from "@/components/FooterSection";
import ContactForm from "@/components/ContactForm";
import { Mail, MapPin } from "lucide-react";
import { useEffect } from "react";

const Contact = () => {
  useEffect(() => {
    document.title = "Contact DocketLabs | AI Legal Consulting";
    window.scrollTo(0, 0);
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Contact DocketLabs for AI legal consulting. Get expert guidance on implementing AI in your law firm.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Contact DocketLabs for AI legal consulting. Get expert guidance on implementing AI in your law firm.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      <main className="bg-background text-foreground pt-24 min-h-screen px-6">
        <div className="container mx-auto max-w-6xl py-12">
          <div className="mb-12 text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              Get in Touch
            </h1>
            <p className="text-xl text-white/80 max-w-3xl mx-auto">
              Have questions about our AI legal solutions? Our team is ready to help.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            {/* Contact Form */}
            <div className="lg:col-span-2">
              <ContactForm />
            </div>

            {/* Contact Info */}
            <div>
              <div className="backdrop-blur-lg bg-white/5 border border-white/10 rounded-2xl p-8 h-full">
                <h2 className="text-2xl font-bold mb-6">Contact Information</h2>
                
                <div className="space-y-8">
                  <div className="flex items-start">
                    <div className="bg-primary/20 p-3 rounded-lg mr-4">
                      <Mail className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-1">Email Us</h3>
                      <a href="mailto:hello@docketlabs.com" className="text-white/80 hover:text-primary transition-colors">
                        hello@docketlabs.com
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="bg-primary/20 p-3 rounded-lg mr-4">
                      <MapPin className="h-6 w-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold mb-1">Visit Us</h3>
                      <address className="text-white/80 not-italic">
                        1935 Addison Street<br />
                        Suite A<br />
                        Berkeley, CA 94704<br />
                        United States
                      </address>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Contact;
